import 'primeicons/primeicons.css';
import { SearchPageIndex } from '../../features/searchpage/Index';
import { useEffect } from 'react';
import { urlPrefix } from '../../constants/constants';
import { AppRouteURL } from '../../routes/app-route-urls';
import { checkIsUserLoggedIn, login } from '../../utils/globalUtilities';


export const SearchPractice = () => {
    useEffect(()=>{
        if (!checkIsUserLoggedIn()) {  
        login();
        window.open(
            `${urlPrefix + "/" + AppRouteURL.LOGIN}`,
            "_self"
          )
        }
    },[window.location.pathname]);

    return (
        <div>
            <SearchPageIndex/>
        </div>
    )
}

export default SearchPractice


 